import { onReady } from "@xatom/core";
import { app } from "./routes";

onReady(() => {
  app();
});
